import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  ShowPlanCartList,
  DeletPlanCartItem,
  AddplanSubscription,
} from "../../../Services/UserService/clientService";
import Content from "../../../components/Contents/Content";
import { NotepadText } from "lucide-react";
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";
import { loadScript } from "../../../../Utils/Razorpayment";
import { basicsettinglist } from "../../../Services/Admin/Admin";
import Kyc from "../Profile/Kyc";
import {
  GetUserData,
  CouponList,
  ApplyCoupon,
} from "../../../Services/UserService/User";
import ReusableModal from "../../../components/Models/ReusableModal";
import ReusableModal1 from "../../../components/Models/ReusableModal1";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../Utils/Loader";
import { Accordion } from "react-bootstrap";

const ServiceCart = () => {
  const token = localStorage.getItem("token");
  const userid = localStorage.getItem("id");
  const navigate = useNavigate();
  const applyButtonRef = useRef(null);

  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [finalPrice, setFinalPrice] = useState(0);
  const [getkey, setGetkey] = useState([]);
  const [company, setCompany] = useState([]);
  const [allKey, setAllKey] = useState([]);
  const [kycStatus, setKycStatus] = useState("");
  const [userdata, setUserdata] = useState([]);
  const [viewmodel2, setViewModel2] = useState(false);
  const [viewmodel3, setViewModel3] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [kyckey, setKyckey] = useState([]);
  const [autoPaymentTriggered, setAutoPaymentTriggered] = useState(false);

  // Coupon states (same as Service page)
  const [coupons, setCoupons] = useState([]);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [manualCoupon, setManualCoupon] = useState("");
  const [coupondata, setCouponData] = useState("");
  const [coupondetails, setCoupondetails] = useState({});
  const [discount, setDiscount] = useState(0);

  // GST states
  const [gstStatus, setGstStatus] = useState();
  const [gstdata, setGstdata] = useState(18);

  const fullUrl = window.location.href;
  const queryString = fullUrl.split("?").slice(1).join("&");
  const searchParams = new URLSearchParams(queryString);
  const urlPlanId = searchParams.get("planid");

  const clearUrlParams = () => {
    const currentUrl = window.location.href;
    const baseUrl = currentUrl.split("?")[0];
    window.history.replaceState({}, document.title, baseUrl);
    const hashPart = window.location.hash.split("?")[0];
    window.location.hash = hashPart;
  };

  useEffect(() => {
    planList();
    getkeybydata();
    fetchUserData();
    fetchCoupon();
  }, []);

  useEffect(() => {
    if (
      !loading &&
      !autoPaymentTriggered &&
      urlPlanId &&
      cartItems.length > 0 &&
      getkey &&
      company &&
      finalPrice > 0
    ) {
      setAutoPaymentTriggered(true);
      setTimeout(() => {
        handleShowModal(cartItems);
      }, 500);
    }
  }, [
    loading,
    cartItems,
    getkey,
    company,
    finalPrice,
    urlPlanId,
    autoPaymentTriggered,
  ]);

  const fetchUserData = async () => {
    try {
      const userData = await GetUserData(userid, token);
      if (userData && userData.data) {
        setUserdata(userData.data);
      }
    } catch (error) {
      showCustomAlert(
        "error",
        "Failed to load user data. Please refresh and try again.",
      );
    }
  };

  const handleShowModal = (item) => {
    if (!userdata?.Email) {
      showCustomAlert("error", "Please Complete The Profile");
      return;
    }
    if (
      kycStatus == 1 &&
      (userdata?.kyc_verification == 0 || userdata?.kyc_verification == 2)
    ) {
      setViewModel2(true);
      setKyckey(item[0]?._id);
    } else {
      AddPlanSubscribeAddToCart(item);
    }
  };

  const getkeybydata = async () => {
    try {
      const response = await basicsettinglist();
      if (response.status) {
        setGetkey(response?.data[0]?.razorpay_key);
        setCompany(response?.data[0]?.from_name);
        setAllKey(response.data[0]);
        setKycStatus(response?.data[0].kyc);
        setGstStatus(response.data[0]?.gststatus);
        setGstdata(response.data[0]?.gst || 18);
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  const planList = async () => {
    try {
      setLoading(true);
      const response = await ShowPlanCartList(userid, token);
      if (response.status) {
        setCartItems(response.data);
      } else {
        setCartItems([]);
      }
    } catch (err) {
      console.log("Error fetching cart:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (item) => {
    try {
      const confirmed = await showCustomAlert(
        "confirm",
        "Do you want to remove this item? This action cannot be undone.",
      );
      if (!confirmed.isConfirmed) return;

      const data = { client_id: userid, id: item?._id };
      const response = await DeletPlanCartItem(data, token);
      if (response.status) {
        showCustomAlert("Success", response.message);
        // Reset coupon on cart change
        removeCoupon();
        planList();
      }
    } catch (error) {
      showCustomAlert("error", "There was an error deleting the cart.");
    }
  };

  const fetchCoupon = async () => {
    try {
      const payload = { client_id: userid };
      const response = await CouponList(payload, token);
      setCoupons(response?.data || []);
    } catch (error) {
      console.error("Coupon error:", error);
    }
  };

  // Same as Service page coupon handlers
  const handleCouponSelect = (coupon) => {
    setManualCoupon(coupon?.code);
    setCouponData(coupon);
    if (applyButtonRef.current) {
      applyButtonRef.current.focus();
    }
  };

  const applyCoupon = async (coupon) => {
    try {
      const data = {
        code: coupon?.code || coupon,
        purchaseValue: totalPrice,
        client_id: userid,
      };
      const response = await ApplyCoupon(data, token);
      if (response.status) {
        showCustomAlert(
          "Success",
          response.message || "Your discount has been applied successfully.",
        );
        setCoupondetails(response);
        setDiscount(response?.discount || 0);
        if (typeof coupon === "string") {
          setAppliedCoupon({ code: coupon });
        } else {
          setAppliedCoupon(coupondata || coupon);
        }
      } else {
        showCustomAlert(
          "error",
          response?.message || "Failed to apply coupon. Please try again.",
        );
      }
    } catch (error) {
      showCustomAlert("error", "Something went wrong. Please try again later.");
    }
  };

  const removeCoupon = () => {
    setManualCoupon("");
    setAppliedCoupon(null);
    setCoupondetails({});
    setDiscount(0);
  };

  const AddPlanSubscribeAddToCart = async (item) => {
    try {
      // Calculate final amount in paise — same logic as Service page
      let finalAmount;
      if (
        coupondetails?.finalPrice !== undefined &&
        coupondetails?.finalPrice !== null
      ) {
        // Coupon applied — use coupon's finalPrice
        finalAmount = Math.round(coupondetails.finalPrice * 100);
      } else {
        // No coupon — calculate with GST if applicable
        const basePrice = totalPrice;
        const gstAmt = gstStatus == 1 ? (basePrice * gstdata) / 100 : 0;
        finalAmount = Math.round((basePrice + gstAmt) * 100);
      }

      // ✅ Zero / 100% off — direct subscribe WITHOUT Razorpay (same as Service page)
      if (finalAmount <= 0) {
        setIsLoading(true);

        const data = {
          plan_ids: item.map((items) => items?.plan_id?._id).filter((id) => id),
          client_id: userid,
          coupon_code: appliedCoupon?.code || 0,
          orderid: "",
          discount: coupondetails?.discount || 0,
          price: 0,
        };

        try {
          const response = await AddplanSubscription(data, token);
          if (response?.status) {
            clearUrlParams();
            if (kycStatus == 2 && userdata?.kyc_verification == 0) {
              setViewModel3(true);
            } else {
              navigate("/user/thankyou", { state: { planType: data } });
            }
          } else {
            showCustomAlert("error", "Failed to subscribe. Please try again.");
          }
        } catch (error) {
          console.error("Error while subscribing:", error);
          showCustomAlert("error", "Subscription failed. Please try again.");
        } finally {
          setIsLoading(false);
        }
        return; // ← Razorpay open nahi hoga
      }

      // 💳 Amount > 0 — open Razorpay normally
      if (!window.Razorpay) {
        await loadScript("https://checkout.razorpay.com/v1/checkout.js");
      }

      const options = {
        key: getkey,
        amount: finalAmount,
        name: company,
        currency: "INR",
        handler: async function (response1) {
          setIsLoading(true);
          const data = {
            plan_ids: item
              .map((items) => items?.plan_id?._id)
              .filter((id) => id),
            client_id: userid,
            coupon_code: appliedCoupon?.code || 0,
            orderid: response1?.razorpay_payment_id,
            discount: coupondetails?.discount || 0,
            price: finalAmount / 100, // paise → rupees for backend
          };
          try {
            const response2 = await AddplanSubscription(data, token);
            setIsLoading(false);
            if (response2?.status) {
              clearUrlParams();
              if (kycStatus == 2 && userdata?.kyc_verification == 0) {
                setViewModel3(true);
              } else {
                navigate("/user/thankyou", { state: { planType: data } });
              }
            }
          } catch (error) {
            console.error("Error while adding plan subscription:", error);
            setIsLoading(false);
          }
        },
        prefill: {},
        theme: { color: "#F37254" },
        modal: {
          ondismiss: function () {
            if (urlPlanId) {
              clearUrlParams();
              setAutoPaymentTriggered(false);
            }
          },
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Subscription error:", error);
      showCustomAlert("error", "Something went wrong. Please try again.");
      setIsLoading(false);
    }
  };

  // Price calculations (same pattern as Service page)
  const totalPrice = cartItems?.reduce(
    (sum, item) => sum + (item.plan_id?.price || 0),
    0,
  );

  const gstAmount = gstStatus == 1 ? (totalPrice * gstdata) / 100 : 0;

  // If coupon applied use coupondetails.finalPrice, else calculate manually
  const computedFinalAmount =
    coupondetails?.finalPrice !== undefined &&
      coupondetails?.finalPrice !== null
      ? coupondetails.finalPrice
      : Math.max(totalPrice + gstAmount - discount, 0);

  useEffect(() => {
    setFinalPrice(Number(computedFinalAmount));
  }, [computedFinalAmount]);

  if (isLoading) {
    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ height: "100vh" }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <Content
      Page_title="Cart"
      backbutton_status={true}
      backbutton_title="Back"
      button_status={false}
    >
      <div className="container mt-4">
        {loading && (
          <div className="text-center">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        )}

        {!loading && cartItems.length > 0 && (
          <div
            className="container"
            style={{ maxHeight: "35vh", overflowY: "auto" }}
          >
            {cartItems?.map((item, index) => (
              <div
                key={index}
                className="card p-3 mb-3 shadow-sm position-relative"
              >
                <button
                  className="btn btn-danger position-absolute"
                  style={{
                    top: "0px",
                    right: "-2px",
                    borderRadius: "15%",
                    width: "40px",
                    height: "30px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => handleDelete(item)}
                >
                  <i className="bi bi-trash" style={{ fontSize: "18px" }}></i>
                </button>

                <div className="d-flex align-items-center">
                  <div
                    className="d-flex justify-content-center align-items-center bg-success rounded-circle"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <NotepadText size={30} style={{ color: "white" }} />
                  </div>
                  <div className="ms-3">
                    <h5 className="mb-1">
                      <b>{item.plan_id?.category?.title || "No Title"}</b>
                    </h5>
                    <p className="mb-1" style={{ color: "#a6a6a6" }}>
                      Validity: {item.plan_id?.validity || "No Validity"}
                    </p>
                    <p className="fw-bold" style={{ color: "#00e600" }}>
                      ₹{item.plan_id?.price?.toLocaleString() || "No Price"}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {!loading && cartItems.length === 0 ? (
          <div className="text-center mt-5">
            <img
              src="/assets/images/nodata.png"
              alt="No Records Found"
              style={{ maxWidth: "300px" }}
            />
          </div>
        ) : (
          <div className="container">
            <h4 className="mt-4 text-light">
              <b>Plan Summary</b>
            </h4>

            {!loading && cartItems.length > 0 && (
              <div
                className="card mt-0"
                style={{ border: "1px solid primary" }}
              >
                <div className="card-body text-light">
                  {/* Price Breakdown */}
                  <div className="d-flex justify-content-between mb-2">
                    <strong>Original Price:</strong>
                    <span className="text-primary fw-bold">
                      ₹{totalPrice.toLocaleString()}
                    </span>
                  </div>

                  {gstStatus == 1 && (
                    <div className="d-flex justify-content-between mb-2">
                      <strong>💰 GST ({gstdata}%):</strong>
                      <span className="text-primary fw-bold">
                        ₹{(coupondetails?.totalgst ?? gstAmount).toFixed(2)}
                      </span>
                    </div>
                  )}

                  {appliedCoupon && discount > 0 && (
                    <div className="d-flex justify-content-between align-items-center text-danger mb-2">
                      <strong>Coupon Discount:</strong>
                      <span className="fw-bold">
                        - ₹{Number(discount).toFixed(2)}
                      </span>
                    </div>
                  )}

                  {/* Coupon Section — same design as Service page */}
                  <Accordion className="mt-3 mb-3">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>🎟️ Apply Coupon Code</Accordion.Header>
                      <Accordion.Body
                        style={{
                          maxHeight: "230px",
                          overflowY: "auto",
                          scrollbarWidth: "thin",
                          padding: "0",
                        }}
                      >
                        {/* Sticky input bar */}
                        <div
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 10,
                            padding: "10px",
                            background: "#18221f",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <input
                              type="text"
                              className="form-control me-2"
                              placeholder="Enter coupon code"
                              value={manualCoupon}
                              onChange={(e) => setManualCoupon(e.target.value)}
                            />
                            {manualCoupon && (
                              <button
                                ref={applyButtonRef}
                                className="btn btn-primary"
                                onClick={() => applyCoupon(manualCoupon)}
                              >
                                Apply
                              </button>
                            )}
                            {appliedCoupon && (
                              <button
                                className="btn btn-danger ms-2"
                                onClick={removeCoupon}
                              >
                                Remove
                              </button>
                            )}
                          </div>
                        </div>

                        {/* Coupon cards list — same design as Service page */}
                        <div className="mt-3 px-2">
                          {coupons.map((coupon) => (
                            <li
                              key={coupon.code}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                border: "1px solid #dcdcdc",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                marginBottom: "15px",
                                borderRadius: "12px",
                                padding: "15px 20px",
                                listStyle: "none",
                                transition: "transform 0.2s, box-shadow 0.2s",
                              }}
                              onMouseOver={(e) => {
                                e.currentTarget.style.transform = "scale(1.02)";
                                e.currentTarget.style.boxShadow =
                                  "0 6px 12px rgba(0, 0, 0, 0.15)";
                              }}
                              onMouseOut={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                                e.currentTarget.style.boxShadow =
                                  "0 4px 8px rgba(0, 0, 0, 0.1)";
                              }}
                            >
                              {/* Vertical service name strip */}
                              <div
                                className="btn-primary"
                                style={{
                                  width: "40px",
                                  height: "160px",
                                  color: "#000",
                                  textAlign: "center",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderTopLeftRadius: "12px",
                                  borderBottomLeftRadius: "12px",
                                  padding: "0",
                                  marginLeft: "-20px",
                                  marginTop: "-20px",
                                  marginBottom: "-20px",
                                }}
                              >
                                {coupon?.serviceName
                                  ?.split("")
                                  .map((char, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        display: "block",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        color: "#000",
                                      }}
                                    >
                                      {char.toUpperCase()}
                                    </div>
                                  ))}
                              </div>

                              {/* Coupon info */}
                              <div
                                style={{
                                  flexGrow: 1,
                                  marginLeft: "15px",
                                  textAlign: "left",
                                }}
                              >
                                <p
                                  style={{
                                    margin: "0 0 5px",
                                    fontWeight: "500",
                                    color: "#ffffffff",
                                    fontSize: "16px",
                                  }}
                                >
                                  Use code{" "}
                                  <span
                                    style={{
                                      fontWeight: "700",
                                      color: "#007bff",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    {coupon?.code}
                                  </span>
                                </p>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    color: "#ffffffff",
                                  }}
                                >
                                  <span
                                    style={{
                                      display: "block",
                                      marginBottom: "4px",
                                    }}
                                  >
                                    🛡️ Validity:{" "}
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {coupon?.enddate?.split("T")[0]}
                                    </span>
                                  </span>
                                  <span
                                    style={{
                                      display: "block",
                                      marginBottom: "4px",
                                    }}
                                  >
                                    💸 Save Upto:{" "}
                                    <strong>
                                      {coupon.type === "fixed"
                                        ? `₹${coupon?.value}`
                                        : `${coupon?.value}%`}
                                    </strong>
                                  </span>
                                  {coupon.type !== "flat" ? (
                                    <span style={{ display: "block" }}>
                                      🛒 Min Purchase:{" "}
                                      <strong>
                                        ₹{coupon?.minpurchasevalue}
                                      </strong>
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>

                              {/* Select button */}
                              <div>
                                <button
                                  onClick={() => handleCouponSelect(coupon)}
                                  className={`btn ${manualCoupon === coupon.code ? "btn-success" : "btn-secondary"}`}
                                  disabled={manualCoupon === coupon.code}
                                >
                                  {manualCoupon === coupon.code
                                    ? "Selected"
                                    : "Select"}
                                </button>
                              </div>
                            </li>
                          ))}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <hr />

                  {/* Grand Total */}
                  <div className="d-flex justify-content-between fw-bold fs-5 mt-2">
                    <strong>Grand Total:</strong>
                    <span className="text-success">
                      ₹
                      {computedFinalAmount.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>

                  <div className="text-center mt-3">
                    <button
                      className="btn btn-primary w-100 fw-bold"
                      onClick={() => handleShowModal(cartItems)}
                      disabled={urlPlanId && autoPaymentTriggered}
                    >
                      {urlPlanId && autoPaymentTriggered
                        ? "Processing..."
                        : "Buy Now"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <ReusableModal
        show={viewmodel2}
        onClose={() => setViewModel2(false)}
        title={<>KYC</>}
        body={
          <Kyc
            onSuccess={() => setViewModel2(false)}
            type="servicecart"
            kyckey={kyckey}
          />
        }
        size="lg"
      />

      <ReusableModal1
        show={viewmodel3}
        onClose={() => setViewModel3(false)}
        title={<>KYC</>}
        body={<Kyc onSuccess={() => setViewModel3(false)} type="servicecart" />}
        disableClose={false}
        size="lg"
      />
    </Content>
  );
};

export default ServiceCart;
